import { Nullable } from 'legacy/lut/classes/models/utils'

import { getFormattedFinance } from 'cng-common/helpers/numbers'
import { QBRRounding } from 'partner360/models/qbr/QBRRounding'

export const getQBRFormattedFinance = (value?: Nullable<string | number>, rounding?: string) => {
  if (value === null || value === undefined) {
    return '-'
  }

  if (rounding === QBRRounding.AsIs) {
    return getFormattedFinance(value, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
  }

  return getFormattedFinance(value)
}
